import React from 'react';

import CheckinBar from '../../chart/CheckinBar';
import ComponentBar from '../../chart/ComponentBar';

const ProgressMetrics = props => {
    if (!props.organization) {
        return null;
    }

    let org = props.organization;

    return (
        <div className="ProgressMetrics">
            <p className="header">Primary Practice Overall Progress</p>

            <div className="metric">
                <label>Core Criteria (complete/planned)</label>
                <CheckinBar checkins={org.core} />
            </div>

            <div className="metric">
                <label>Elective Criteria (complete/planned)</label>
                <CheckinBar checkins={org.elective} />
            </div>

            {org.use_nys && (
                <div className="metric">
                    <label>NYS Required Criteria (complete/planned)</label>
                    <CheckinBar checkins={org.nysrequired} />
                </div>
            )}

            <div className="metric">
                <label>Components/Check-in</label>
                <ComponentBar checkins={org.components} />
            </div>
        </div>
    );
};

export default ProgressMetrics;
